"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderWithCashback = void 0;
var HeaderWithCashback_1 = require("./HeaderWithCashback");
Object.defineProperty(exports, "HeaderWithCashback", { enumerable: true, get: function () { return __importDefault(HeaderWithCashback_1).default; } });
